import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { CarRegistrationNumberButtonControlProps } from './CarRegistrationNumberButtonControl.interfaces';
import CarRegistrationNumberEditButton from 'app/components/CarRegistrationNumberEditButton';
import { ControlContainer } from 'app/components/ControlContainer';
import { CarSelectControlTooltip } from 'app/components/CarSelectControlTooltip';
import { addReturnDataLayerEvent } from 'app/store/thunks/addCalculationPageDataLayerEvent';
import { FormsConfigActions } from 'app/store/data/formsConfig';

export default function CarRegistrationNumberButtonControl(
  props: CarRegistrationNumberButtonControlProps
) {
  const { formName, input } = props;

  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(
      addReturnDataLayerEvent({
        eventName: 'return_click',
        elementName: 'Edycja rejestracji',
        eventLocation: 'strona_kalkulacji',
        stepName: 'formularz_step_1',
      })
    );
    dispatch(FormsConfigActions.setFirstStepMode(true));
  }, [dispatch]);

  return (
    <ControlContainer
      inputId={input.name}
      tooltip={formName && <CarSelectControlTooltip formName={formName} />}
    >
      <CarRegistrationNumberEditButton
        label={input.value}
        onClick={handleClick}
      />
    </ControlContainer>
  );
}
